const es = {
  // Nav
  nav_home: 'Inicio',
  nav_products: 'Productos',
  nav_about: 'Sobre Nosotros',
  nav_contact: 'Contacto',
  nav_explore: 'Explorar',

  // Hero
  hero_badge: 'Rascadores · Calidad Profesional',
  hero_title1: 'Viviendo con Gatos',
  hero_title2: 'Cada Arañazo',
  hero_title3: 'Es un Ritual de Alegría',
  hero_desc: 'Materiales naturales premium combinados con diseño ergonómico — ayudando a los gatos a amar sus rascadores y haciendo tu hogar más hermoso. Koorpet, protegiendo la felicidad detrás de cada huella.',
  hero_btn_products: 'Explorar Productos',
  hero_btn_about: 'Nuestra Historia',
  hero_stat1_num: '6+',
  hero_stat1_label: 'Años en el Sector',
  hero_stat2_num: '50+',
  hero_stat2_label: 'Líneas de Productos',
  hero_stat3_num: '100K+',
  hero_stat3_label: 'Gatos Confían en Nosotros',
  hero_scroll: 'Desplazar Abajo',

  // Featured Products
  featured_label: 'Productos Destacados',
  featured_title: 'Más Vendidos',
  featured_subtitle: 'Colección Favorita de los Gatos',
  featured_view_all: 'Ver Todos los Productos',
  featured_empty: 'Aún no hay productos destacados',

  // Features Section
  features_badge: 'Ventajas Clave',
  features_title: 'Por Qué Elegir Koorpet',
  features_desc: 'Cada producto pasa por rigurosas pruebas de I+D para ofrecer a los gatos la mejor experiencia de rascado',
  feature1_title: 'Alta Densidad de Triple Capa',
  feature1_desc: 'Cartón corrugado premium con tecnología de prensado en caliente triple, 2 veces más denso que los productos comunes, más duradero y resistente.',
  feature2_title: 'Infusión Natural de Catnip',
  feature2_desc: 'Catnip orgánico infusionado uniformemente entre las capas de cartón, liberando fragancia natural duradera que atrae a los gatos.',
  feature3_title: 'Certificación Eco No Tóxica',
  feature3_desc: 'Todos los materiales pasan pruebas ambientales nacionales — sin formaldehído, sin metales pesados, seguro incluso si los gatos lo muerden.',
  feature4_title: 'Diseño Ergonómico',
  feature4_desc: 'Basado en investigaciones sobre comportamiento felino, ángulos y alturas optimizados que combinan perfectamente con la postura natural de rascado de los gatos.',

  // Brand Section
  brand_label: 'Artesanía Dedicada',
  brand_title1: 'Artesanía Dedicada',
  brand_title2: 'Por Un Rascador Perfecto',
  brand_desc: 'Fundada en 2024, Koorpet es una marca líder dedicada a la I+D y producción de rascadores en China. Nuestra fábrica abarca 4.000 metros cuadrados con líneas de producción totalmente automatizadas y una capacidad anual de 2 millones de unidades. Creemos que un buen rascador no solo protege los muebles, sino que también mejora la calidad de vida de los gatos.',
  brand_years_num: '2024',
  brand_years_label: 'Fundada En',
  brand_years_desc: 'Con una fábrica moderna de 4.000 m² y líneas de producción totalmente automatizadas, proporcionando rascadores de alta calidad para familias de gatos en todo el mundo.',
  brand_cert1_label: 'Cert. Nacional de Calidad',
  brand_cert1_sub: 'Certificado ISO 9001',
  brand_cert2_label: 'Materiales Eco Naturales',
  brand_cert2_sub: 'Certificado No Tóxico',
  brand_cert3_label: 'Exportación a 10+ Países',
  brand_cert3_sub: 'Estándares Internacionales',
  brand_cert4_label: '100K+ Gatos',
  brand_cert4_sub: 'Elección de Confianza',
  brand_cta: '',

  // CTA Section
  cta_quote_label: 'Voz de los Dueños de Gatos',
  cta_quote: '"¡Desde que uso Koorpet, mi sofá está por fin a salvo!"',
  cta_label: 'Actúa Ahora',
  cta_title1: 'Deja que Tu Gato Ame',
  cta_title2: 'Su Propio Territorio',
  cta_desc: 'Más de 100 mil gatos ya han elegido Koorpet. Materiales naturales, diseño cuidadoso, control de calidad riguroso — cada producto es el mejor regalo para tu gato. Pide ahora y disfruta de calidad de vida.',
  cta_btn: 'Comprar Ahora',

  // Reviews Section
  reviews_title: 'Reseñas Reales de Dueños de Gatos:',
  reviews_subtitle: 'Reseñas genuinas de dueños de gatos de todo el país',
  review1_name: 'Mamá del Gato Naranja',
  review1_content: '¡Compré la Serie Nube y mi gato naranja se enamoró el primer día! Excelente calidad, cartón grueso y resistente, el olor a catnip lo atrae muchísimo. ¡Muy recomendado!',
  review1_product: 'Rascador Serie Nube',
  review2_name: 'Dueño de Ragdoll',
  review2_content: 'El Poste de Sisal está elaborado con mucho cuidado, la cuerda de sisal está enrollada firmemente, la base es muy estable. ¡Mi ragdoll se rasca en él todos los días, el sofá está por fin a salvo!',
  review2_product: 'Poste Rascador de Sisal',
  review3_name: 'Humana de la Gata Tricolor',
  review3_content: 'El Rascador Ondulado tiene un diseño inteligente, reversible para el doble de vida útil, increíble relación calidad-precio. ¡A mi gata le encanta dormir sobre él, dos pájaros de un tiro!',
  review3_product: 'Rascador Ondulado para Gatos',
  review4_name: 'Papá del British Shorthair',
  review4_content: 'Embalaje muy cuidadoso, calidad del producto impecable. El servicio al cliente es muy rápido, respuestas al instante. ¡He recomprado tres veces, es la marca favorita de mi gato!',
  review4_product: 'Rascador Redondo con Catnip',

  // About Banner
  about_breadcrumb_home: 'Inicio',
  about_breadcrumb_about: 'Sobre Nosotros',
  about_banner_title: 'Sobre Koorpet',
  about_banner_desc: 'Artesanía y calidad, dedicados a la felicidad de cada gato. Creemos que los grandes productos hacen que el vínculo entre personas y mascotas sea aún más hermoso.',

  // Company Stats
  stat1_num: '2024',
  stat1_label: 'Fundada',
  stat1_sub: 'Profundos en el sector pet',
  stat2_num: '50+',
  stat2_label: 'Productos',
  stat2_sub: 'Cubriendo todos los escenarios felinos',
  stat3_num: '100K+',
  stat3_label: 'Gatos',
  stat3_sub: 'Confían en Koorpet',
  stat4_num: '30+',
  stat4_label: 'Patentes',
  stat4_sub: 'Innovación continua',

  // Brand Story
  story_label: 'Nuestra Historia',
  story_float_num: '2024',
  story_float_desc: 'Profundos en el sector de rascadores, enfocados en calidad e innovación',
  story_title1: 'De Un Rascador',
  story_title2: 'al Nacimiento de una Marca',
  story_p1: 'Fundada en 2024, Koorpet es una marca líder dedicada a la I+D y producción de rascadores en China. Operamos una fábrica moderna de 4.000 metros cuadrados con líneas de producción totalmente automatizadas y una capacidad anual de 2 millones de unidades.',
  story_p2: 'Con años de experiencia en el sector pet, nuestro fundador reconoció la falta de productos en el mercado que realmente buscan calidad y diseño de experiencia de usuario. Decidido a crear Koorpet, se propuso redefinir el rascador con estándares más altos.',
  story_p3: 'Desde la selección de materias primas hasta el producto final, cada proceso pasa por un riguroso control de calidad. Seguimos la filosofía de "materiales naturales, diseño cuidadoso, control de calidad riguroso", dedicados a proporcionar la mejor experiencia de rascado para cada gato. Hoy, Koorpet se ha convertido en una marca confiable de rascadores, con productos vendidos en muchos países y regiones.',
  story_founder_name: 'John Yu',
  story_founder_role: 'Fundador de Koorpet',
  story_founder_quote: '"No solo hacemos rascadores — creamos un espacio de convivencia mejor para cada familia de gatos."',

  // Timeline
  timeline_label: 'Hitos',
  timeline_title: 'Nuestro Trayecto',
  timeline_desc: 'De la fabricación OEM a la marca propia, cada paso es firme. Estas son las huellas del crecimiento de Koorpet.',
  milestone1_title: 'Lanzamiento del Negocio OEM',
  milestone1_desc: 'Comenzamos a ofrecer servicios de fabricación OEM de rascadores para marcas internacionales de mascotas, estableciendo bases de cadena de suministro y construyendo experiencia en producción y control de calidad.',
  milestone2_title: 'Expansión de la Fábrica',
  milestone2_desc: 'Ampliamos una fábrica moderna de 4.000 m², introdujimos líneas de producción totalmente automatizadas, con capacidad anual de 5 millones de unidades.',
  milestone3_title: 'Avance en Exportaciones',
  milestone3_desc: 'Productos OEM exportados a más de 10 países y regiones, atendiendo a más de 50 clientes internacionales, con calidad reconocida internacionalmente.',
  milestone4_title: 'Preparación de la Marca',
  milestone4_desc: 'Reunimos un equipo independiente de I+D, preparamos la marca propia Koorpet, completamos el primer lote de diseños originales de productos y patentes.',
  milestone5_title: 'Koorpet Establecida',
  milestone5_desc: 'La marca Koorpet se estableció oficialmente, la primera serie de rascadores de cartón corrugado de alta densidad se lanzó con gran recepción en el mercado.',
  milestone6_title: 'Expansión de Línea de Productos',
  milestone6_desc: 'Lanzamos postes de sisal, serie de árboles para gatos y otros nuevos productos, obtuvimos ISO 9001 y otras certificaciones internacionales, la influencia de la marca continuó expandiéndose.',
  milestone7_title: 'Hito de Usuarios',
  milestone7_desc: 'Hemos atendido a más de 100 mil familias de gatos, Koorpet se ha convertido en una marca líder de rascadores en China, continuando liderando el sector.',

  // Team Section
  team_label: 'Nuestro Equipo',
  team_title: 'Equipo Principal',
  team_desc: 'Un grupo de verdaderos amantes de los gatos, creando cada producto con experiencia y pasión',
  team_more: 'Más',
  team_more2: 'miembros apasionados del equipo profesional Koorpet',
  team1_name: 'John Yu',
  team1_role: 'Fundador',
  team1_desc: 'Anteriormente director de canal en una empresa líder del sector, con profundo conocimiento del mercado de productos para mascotas. Basado en una comprensión profunda del bienestar felino y una búsqueda incansable de la calidad del producto, fundó Koorpet en 2024, liderando al equipo de la fabricación OEM a la marca propia.',
  team1_tag1: 'Fundación de la Marca',
  team1_tag2: 'Expansión de Canales',
  team2_name: 'Lin Xiaowen',
  team2_role: 'Diseñadora Jefe',
  team2_desc: 'Graduada de la Academia Central de Bellas Artes en Diseño Industrial, 8 años en diseño de productos para mascotas, lideró el diseño de apariencia de más de 30 productos Koorpet.',
  team2_tag1: 'Diseño de Producto',
  team2_tag2: 'Experiencia de Usuario',
  team3_name: 'Wang Jianguo',
  team3_role: 'Director de I+D',
  team3_desc: 'Doctor en Ingeniería de Materiales, 10 años enfocado en I+D de materiales para productos de mascotas, lideró el desarrollo de la fórmula de bajo polvo y el proceso de infusión de catnip de Koorpet.',
  team3_tag1: 'I+D de Materiales',
  team3_tag2: 'Innovación de Procesos',
  team4_name: 'Zhang Meiling',
  team4_role: 'Directora de Calidad',
  team4_desc: 'Posee certificación del sistema de gestión de calidad ISO, responsable del control de calidad en todas las líneas de productos Koorpet, garantizando que cada producto cumpla con los estándares de fábrica.',
  team4_tag1: 'Control de Calidad',
  team4_tag2: 'Certificado ISO',

  // Certificates
  cert_label: 'Certificaciones',
  cert_title: 'Credenciales y Certificaciones',
  cert_desc: 'Múltiples certificaciones de autoridad — la mejor prueba de la calidad e innovación de Koorpet',
  cert1_title: 'ISO 9001',
  cert1_sub: 'Sistema de Gestión de Calidad',
  cert1_desc: 'Aprobó la certificación internacional del sistema de gestión de calidad, proceso de producción totalmente rastreable, calidad garantizada.',
  cert1_year: 'Obtenida en 2018',
  cert2_title: 'Cert. Eco No Tóxico',
  cert2_sub: 'Prueba Eco Nacional Aprobada',
  cert2_desc: 'Todos los materiales pasan pruebas ambientales nacionales — sin formaldehído, sin metales pesados, seguro incluso si los gatos lo muerden.',
  cert2_year: 'Obtenida en 2017',
  cert3_title: 'Cert. de Seguridad Pet',
  cert3_sub: 'Asociación China de Productos Pet',
  cert3_desc: 'Certificación de seguridad otorgada por la Asociación China de Productos Pet, una de las pocas marcas del sector en recibir esta certificación.',
  cert3_year: 'Obtenida en 2019',
  cert4_title: 'Cert. CE Europea',
  cert4_sub: 'Acceso al Mercado de la UE',
  cert4_desc: 'Aprobó la certificación CE de la UE, los productos cumplen con los estándares de seguridad, salud y medio ambiente de la UE, aptos para la venta en el mercado de la UE.',
  cert4_year: 'Obtenida en 2020',
  awards_title: 'Premios',
  award1_title: 'Premio al Diseño Innovador de Productos Pet',
  award1_org: 'Expo de la Industria Pet de China',
  award2_title: 'Marca Más Confiable para Dueños de Gatos',
  award2_org: 'Selección Anual Pet Home',
  award3_title: 'Reconocimiento como Empresa Nacional de Alta Tecnología',
  award3_org: 'Departamento de Ciencia y Tecnología de Guangdong',
  award4_title: 'Marca Famosa de Guangdong',
  award4_org: 'Administración de Industria y Comercio de Guangdong',
  award5_title: 'Empresa Exportadora de Calidad en Productos Pet',
  award5_org: 'Departamento de Comercio de Guangzhou',
  award6_title: 'Excelente PYME de Guangzhou',
  award6_org: 'Departamento de Industria y TI de Guangzhou',

  // About CTA
  about_cta_label: 'Únete a Nosotros',
  about_cta_title1: 'Juntos, Creemos',
  about_cta_title2: 'Una Vida Mejor para los Gatos',
  about_cta_btn1: 'Explorar Productos',
  about_cta_btn2: 'Contáctanos',

  // Products Banner
  products_breadcrumb_home: 'Inicio',
  products_breadcrumb: 'Productos',
  products_banner_title: 'Centro de Productos',
  products_banner_desc: 'Materiales naturales premium, elaborados con cuidado — cada rascador hecho para que los gatos amen su ritual de rascado',

  // Products CTA
  products_cta_title: '¿No Encuentras el Producto Adecuado?',
  products_cta_desc: 'Contáctanos para soluciones personalizadas para tus necesidades específicas',
  products_cta_btn: 'Contáctanos',

  // Product Filter
  filter_all: 'Todos',
  filter_count: '',
  filter_count2: 'productos encontrados',
  sort_default: 'Predeterminado',
  sort_price_asc: 'Precio: Menor a Mayor',
  sort_price_desc: 'Precio: Mayor a Menor',
  category_corrugated: 'Cartón',
  category_sisal: 'Sisal',
  category_combo: 'Combo',

  // Product Card
  product_view_detail: 'Ver Detalles',

  // Product Detail
  detail_product_code: 'Código del Producto',
  detail_not_found: 'Producto no encontrado',
  detail_back_to_products: 'Volver a Productos',

  // Tags
  tag_hot_selling: 'Más Vendido',
  tag_new: 'Nuevo',
  tag_corrugated_paper: 'Cartón',
  tag_limited_offer: 'Oferta Limitada',
  tag_bestseller: 'Superventas',
  tag_recommended: 'Recomendado',
  tag_catnip: 'Catnip',
  tag_sisal: 'Sisal',
  tag_corner_protector: 'Protector de Esquina',
  tag_cat_tree: 'Árbol para Gatos',
  tag_eco_friendly: 'Ecológico',

  detail_tab_desc: 'Descripción',
  detail_tab_specs: 'Especificaciones',
  detail_tab_faq: 'Preguntas Frecuentes',
  detail_spec_material: 'Material',
  detail_spec_size: 'Tamaño',
  detail_spec_weight: 'Peso',
  detail_spec_moq: 'MOQ',
  detail_spec_suitable: 'Apto Para',
  detail_spec_suitable_val: 'Todos los tamaños',
  detail_spec_package: 'Contenido del Paquete',
  detail_spec_package_val: 'Producto × 1, Manual × 1',

  detail_save: 'Ahorra ',
  detail_save_unit: '',
  detail_btn_consult: 'Consultar para Comprar',
  related_title: 'También Te Puede Gustar',
  related_view_all: 'Ver Todos',

  // Highlight Titles
  highlight_title_triple_layer: 'Prensado Triple Capa',
  highlight_title_catnip_infused: 'Catnip Orgánico Infundido',
  highlight_title_eco_certified: 'Certificación Eco No-Tóxica',
  highlight_title_anti_slip: 'Base Antideslizante',
  highlight_title_natural_sisal: 'Sisal Natural',
  highlight_title_solid_wood: 'Base de Madera Maciza',
  highlight_title_golden_height: 'Altura Óptima 60cm',
  highlight_title_nail_care: 'Cuidado Natural de Uñas',
  highlight_title_double_sided: 'Reversible',
  highlight_title_wave_curve: 'Diseño Curvo Ondulado',
  highlight_title_low_dust: 'Fórmula Bajo Polvo',
  highlight_title_rubber_strip: 'Tira de Goma Antideslizante',
  highlight_title_sofa_design: 'Diseñado para Sofás',
  highlight_title_tool_free: 'Sin Herramientas',
  highlight_title_sofa_safe: 'No Daña el Sofá',
  highlight_title_set_of_4: 'Juego de 4',
  highlight_title_catnip_builtin: 'Catnip Incorporado',
  highlight_title_round_design: 'Diseño Redondo Elegante',
  highlight_title_safe_edge: 'Bordes con Acabado Seguro',
  highlight_title_hot_seller: 'Superventas',
  highlight_title_three_level: 'Plataforma de Tres Niveles',
  highlight_title_15kg_capacity: 'Soporta 15kg+',
  highlight_title_hanging_toy: 'Juguete Colgante',
  highlight_title_wide_base: 'Base Amplia y Estable',

  // Highlight Descriptions
  highlight_desc_triple_layer: 'El doble de denso que productos comunes, más duradero',
  highlight_desc_catnip_infused: 'Aroma duradero, atrae a los gatos naturalmente',
  highlight_desc_eco_certified: 'Seguro incluso si lo muerden',
  highlight_desc_anti_slip: 'Se mantiene firme durante el uso',
  highlight_desc_natural_sisal: 'Enrollado a mano, uniforme y resistente',
  highlight_desc_solid_wood: 'Pino tratado, estable y no se vuelca',
  highlight_desc_golden_height: 'Satisface las necesidades de estiramiento del gato',
  highlight_desc_nail_care: 'Lima las uñas eficazmente, protege los muebles',
  highlight_desc_double_sided: 'Voltéalo y sigue usándolo, el doble de vida útil',
  highlight_desc_wave_curve: 'Se adapta a la postura natural de rascado',
  highlight_desc_low_dust: 'Menos residuos, mantiene el hogar limpio',
  highlight_desc_sofa_design: 'Se ajusta perfectamente a las esquinas del sofá, protección total',
  highlight_desc_tool_free: 'Velcro fuerte, listo en 30 segundos',
  highlight_desc_sofa_safe: 'Capa protectora trasera, sin marcas',
  highlight_desc_set_of_4: 'Protege las cuatro esquinas del sofá a la vez',
  highlight_desc_catnip_builtin: 'Resuelve que los gatos ignoren el rascador',
  highlight_desc_round_design: 'Uso plano o en pared, dos en uno',
  highlight_desc_safe_edge: 'Sin rebabas, seguro para gatos',
  highlight_desc_hot_seller: 'Más de 5000 vendidos al mes, muy valorado',
  highlight_desc_three_level: 'Satisface el amor de los gatos por las alturas',
  highlight_desc_15kg_capacity: 'Apto para hogares con varios gatos',
  highlight_desc_hanging_toy: 'Estimula el interés de juego del gato',
  highlight_desc_wide_base: 'No se vuelca ni al saltar',

  // Additional Tags
  tag_double_sided: 'Doble Cara',
  tag_sofa_protector: 'Protector de Sofá',
  tag_multi_function: 'Multifunción',

  // Contact Banner
  contact_breadcrumb_home: 'Inicio',
  contact_breadcrumb: 'Contacto',
  contact_banner_title: 'Contáctanos',
  contact_banner_desc: 'Ya sea para consultas sobre productos, cooperación comercial o servicio postventa, siempre estamos listos para ayudar',

  // Contact Form
  contact_form_label: 'Enviar Mensaje',
  contact_form_title: 'Déjanos un Mensaje',
  contact_form_desc: 'Completa el formulario a continuación y te responderemos en 1 día hábil',
  contact_form_success_title: '¡Mensaje Enviado!',
  contact_form_success_desc: 'Gracias por tu mensaje. Te contactaremos en 1 día hábil.',
  contact_form_success_btn: 'Enviar Otro',
  contact_form_name: 'Tu Nombre',
  contact_form_name_placeholder: 'Ingresa tu nombre',
  contact_form_phone: 'Número de Teléfono',
  contact_form_phone_placeholder: 'Ingresa tu teléfono',
  contact_form_email: 'Correo Electrónico',
  contact_form_email_placeholder: 'Ingresa tu correo electrónico',
  contact_form_inquiry: 'Tipo de Consulta',
  contact_form_company: 'Nombre de la Empresa',
  contact_form_company_optional: '(Opcional)',
  contact_form_company_placeholder: 'Ingresa el nombre de la empresa si corresponde',
  contact_form_message: 'Mensaje',
  contact_form_message_placeholder: 'Describe tus necesidades o preguntas en detalle...',
  contact_form_required: '*',
  contact_form_error: 'Error al enviar. Inténtalo de nuevo.',
  contact_form_sending: 'Enviando...',
  contact_form_submit: 'Enviar Mensaje',
  inquiry_type1: 'Consulta de Producto',
  inquiry_type2: 'Cooperación Mayorista',
  inquiry_type3: 'Servicio Postventa',
  inquiry_type4: 'Cooperación de Medios',
  inquiry_type5: 'Otros',

  // Contact CTA
  contact_cta_title: '¿Aún Tienes Preguntas?',
  contact_cta_desc: 'Consulta nuestro FAQ o envíanos un correo a',
  contact_cta_btn_browse: 'Ver Productos',
  contact_cta_btn_email: 'Enviar Correo',

  // Contact Info
  contact_info1_title: 'Dirección de la Empresa',
  contact_info1_line1: 'FLAT /RM A 9/F SILVERCORP',
  contact_info1_line2: 'INTERNATIONAL TOWER 707-713 NATHAN ROAD MONGKOK HONGKONG',
  contact_info1_action: 'Ver Mapa',
  contact_info2_title: 'Atención al Cliente',
  contact_info2_line1: 'Atención al Cliente',
  contact_info2_line2: 'Lun–Vie 9:00 – 18:00',
  contact_info2_action: 'Chatear Ahora',
  contact_info3_title: 'Correo Electrónico',
  contact_info3_line1: 'cs@koorpet.com',
  contact_info3_line2: 'Negocios: cs@koorpet.com',
  contact_info3_action: 'Enviar Correo',
  contact_info4_title: 'WhatsApp',
  contact_info4_line1: 'Koorpet Oficial',
  contact_info4_line2: 'Chatea con nosotros directamente en WhatsApp',
  contact_info4_action: 'Iniciar Chat',

  // Footer
  footer_brand_desc: 'Dedicados a la I+D y producción de rascadores, dando a cada gato su propio territorio feliz.',
  footer_nav_title: 'Enlaces Rápidos',
  footer_products_title: 'Líneas de Productos',
  footer_product1: 'Rascadores de Cartón',
  footer_product2: 'Postes de Sisal',
  footer_product3: 'Serie Árbol para Gatos',
  footer_product4: 'Protectores de Esquinas',
  footer_product5: 'Serie Catnip',
  footer_contact_title: 'Contáctanos',
  footer_address: 'FLAT /RM A 9/F SILVERCORP INTERNATIONAL TOWER 707-713 NATHAN ROAD MONGKOK HONGKONG',
  footer_phone: 'Lun–Vie 9:00 – 18:00',
  footer_whatsapp: 'WhatsApp',
  footer_email: 'cs@koorpet.com',
  footer_hours: 'Lun–Vie 9:00 – 18:00',
  footer_copyright: '© 2026 DANA INTERNATIONAL (HK) CO., LIMITED',
  footer_privacy: 'Política de Privacidad',
  footer_terms: 'Términos de Uso',
  footer_admin: 'Administración',

  // Legal Page
  legal_breadcrumb: 'Legal',
  legal_banner_title: 'Información Legal',
  legal_banner_desc: 'Lee los siguientes términos cuidadosamente para entender cómo protegemos tus derechos',
  legal_updated: 'Última actualización',

  // Privacy Policy
  privacy_s1_title: 'Sobre Esta Política',
  privacy_s1_p1: 'DANA INTERNATIONAL (HK) CO., LIMITED (en adelante "Koorpet" o "nosotros") toma muy en serio la privacidad del usuario. Esta Política de Privacidad explica cómo recopilamos, usamos, almacenamos y protegemos tu información personal.',
  privacy_s1_p2: 'Al usar nuestro sitio web, productos o servicios, aceptas los términos de esta Política de Privacidad. Si no estás de acuerdo, deja de usar nuestros servicios.',
  privacy_s2_title: 'Información que Recopilamos',
  privacy_s2_p1: 'Para proporcionar mejores servicios, podemos recopilar los siguientes tipos de información:',
  privacy_s2_li1: 'Información de identidad: nombre, número de teléfono, dirección de correo electrónico',
  privacy_s2_li2: 'Información de transacciones: historial de pedidos, dirección de envío, detalles de pago',
  privacy_s2_li3: 'Información del dispositivo: dirección IP, tipo de navegador, sistema operativo',
  privacy_s2_li4: 'Datos de uso: registros de visitas a páginas, comportamiento de clics, palabras clave de búsqueda',
  privacy_s3_title: 'Cómo Usamos Tu Información',
  privacy_s3_p1: 'La información que recopilamos se utilizará para los siguientes fines:',
  privacy_s3_li1: 'Procesar tus pedidos y proporcionar servicios postventa relacionados',
  privacy_s3_li2: 'Enviarte actualizaciones de productos y notificaciones promocionales (puedes cancelar en cualquier momento)',
  privacy_s3_li3: 'Mejorar la funcionalidad de nuestro sitio web y la experiencia del usuario',
  privacy_s4_title: 'Compartición y Divulgación de Información',
  privacy_s4_p1: 'No vendemos tu información personal a terceros. Podemos compartir tu información en las siguientes circunstancias:',
  privacy_s4_p2: 'Compartir información de envío con socios logísticos; cumplir con requisitos legales; con tu autorización explícita.',
  privacy_s5_title: 'Seguridad de la Información',
  privacy_s5_p1: 'Utilizamos medidas de seguridad estándar de la industria para proteger tu información personal, incluida la transmisión cifrada SSL y controles de acceso a datos. Ten en cuenta que la transmisión por internet no es absolutamente segura y no podemos garantizar la seguridad absoluta de la transmisión de información.',
  privacy_s6_title: 'Tus Derechos',
  privacy_s6_p1: 'Tienes los siguientes derechos con respecto a tu información personal:',
  privacy_s6_li1: 'Derecho de acceso: Puedes acceder a tu información personal que conservamos en cualquier momento',
  privacy_s6_li2: 'Derecho de corrección: Si la información es incorrecta, puedes solicitar que la corrijamos',
  privacy_s6_li3: 'Derecho de eliminación: En ciertas circunstancias, puedes solicitar que eliminemos tu información personal',
  privacy_s7_title: 'Contáctanos',
  privacy_s7_p1: 'Si tienes preguntas sobre esta Política de Privacidad, contáctanos en:',

  // Terms of Use
  terms_s1_title: 'Aceptación de los Términos',
  terms_s1_p1: 'Bienvenido al sitio web oficial de Koorpet. Al acceder o usar este sitio web, aceptas estar sujeto a estos Términos de Uso.',
  terms_s1_p2: 'Nos reservamos el derecho de modificar estos términos en cualquier momento. Los términos modificados se publicarán en el sitio web y el uso continuado del sitio web constituye la aceptación de los términos modificados.',
  terms_s2_title: 'Productos y Compras',
  terms_s2_p1: 'Al comprar productos a través de este sitio web, debes cumplir con lo siguiente:',
  terms_s2_li1: 'Toda la información que proporciones debe ser verdadera, precisa y completa',
  terms_s2_li2: 'Debes tener al menos 18 años o usar el servicio con consentimiento del tutor',
  terms_s2_li3: 'Los precios de los productos pueden cambiar en cualquier momento; se aplica el precio mostrado al momento del pedido',
  terms_s3_title: 'Envío y Entrega',
  terms_s3_p1: 'Haremos todos los esfuerzos para entregar los productos dentro del plazo prometido, pero los tiempos reales de entrega pueden variar debido a condiciones logísticas.',
  terms_s3_p2: 'El alcance de entrega, los gastos de envío y los tiempos estimados de llegada están sujetos a lo que se muestre en la página de pago. En caso de retrasos por fuerza mayor, te notificaremos oportunamente.',
  terms_s4_title: 'Política de Devolución y Cambio',
  terms_s4_p1: 'Estamos comprometidos a proporcionar un excelente servicio postventa. Nuestra política de devolución y cambio es la siguiente:',
  terms_s4_li1: 'Dentro de los 7 días posteriores a la recepción del producto, si hay un problema de calidad, puedes solicitar una devolución o cambio',
  terms_s4_li2: 'Los productos deben estar en su embalaje original, sin usar y sin daños',
  terms_s4_li3: 'Los costos de envío de devolución corren a cargo de la parte responsable; si es un problema de calidad, nosotros asumimos los costos de envío',
  terms_s5_title: 'Propiedad Intelectual',
  terms_s5_p1: 'Todo el contenido de este sitio web, incluyendo pero no limitado a textos, imágenes, logotipos y diseños de productos, está protegido por leyes de propiedad intelectual y pertenece a Koorpet.',
  terms_s5_p2: 'Sin nuestro permiso por escrito, no puedes copiar, modificar, distribuir o usar ningún contenido de este sitio web de ninguna manera.',
  terms_s6_title: 'Descargo de Responsabilidad',
  terms_s6_p1: 'El contenido de este sitio web es solo para referencia. No nos hacemos responsables de pérdidas directas o indirectas derivadas del uso de este sitio web o de la confianza en su información. Las imágenes de los productos son solo para referencia; el producto real recibido prevalece.',
  terms_s7_title: 'Ley Aplicable',
  terms_s7_p1: 'Estos Términos de Uso se rigen por las leyes de la República Popular China. En caso de disputas, ambas partes intentarán primero resolverlas mediante negociación; si la negociación falla, la disputa se someterá a los tribunales competentes en Hong Kong SAR.',
  terms_s8_title: 'Contáctanos',
  terms_s8_p1: 'Si tienes preguntas sobre estos Términos de Uso, contáctanos en:',
};

export default es;